import React from 'react';

// WORDPRESS components
import {
  Flex,
  FlexItem,
  FlexBlock,
  DropdownMenu,
  __experimentalInputControl as InputControl,
  Button,
} from '@wordpress/components';
import { trash, moreVertical, edit } from '@wordpress/icons';

// LOCAL scripts
import { getAccessToken } from '../../shared/utils';

// LOCAL components
import Thumb from '../../../assets/widgetic_icon.png';

const defaultBlockName = 'Block Name';

class CompositionItem extends React.Component {
  constructor(props) {
    super(props);
    // console.log('CompositionsItem CTR:', props.content);
    this.state = {
      isEdit: false,
      compName: '',
      compositions: [],
      dataAvailable: false,
    };
  }

  // shouldComponentUpdate(prevProps, prevState) {
  //   console.log('CompsList should update:', this.props.shouldRender);
  //   return this.props.shouldRender;
  // }

  /** COMPONENT DID MOUNT FUNCTION */
  async componentDidMount() {
    // console.log('CompositionItem didMount:', this.props.item.composition);
    if (!this.props.item.composition)
      this.loadCompostion(this.props.item.attrs.compId);
    else this.setState({ compName: this.props.item.composition.name });
  }

  // LOAD function
  async loadCompostion(compId) {
    // auth for widgetic api
    const data = await getAccessToken();
    window.Widgetic.auth.token(data.token);

    // call Widgetic API
    Widgetic.api('compositions/' + compId)
      .then((composition) => {
        // console.log('Loaded composition:', composition);

        // update in state
        this.setState({ compName: composition.name || defaultBlockName });

        // update item in parent
        this.props.addCompToBlock(composition);
      })
      .fail((error) => {
        // console.log('loading composition error:', error);

        // update in state
        this.setState({ compName: defaultBlockName });

        // update item in parent
        this.props.addCompToBlock({ id: compId, name: defaultBlockName });
      });
  }

  // RENAME function
  async renameItem() {
    // console.log('about to rename comp %s to:', this.props.item.composition, this.state.compName);

    // update the name in comp object
    let compObj = this.props.item.composition;
    compObj.name = this.state.compName;

    // rename Composition on Widgetic
    Widgetic.api('compositions/' + compObj.id, 'PUT', JSON.stringify(compObj))
      .then((composition) => {
        // console.log('Composition renamed:', composition, compObj);

        // update item in parent
        this.props.addCompToBlock(composition);
      })
      .fail((error) => {
        console.log('error renaming composition:', error.message);
      });
  }

  // TRASH function
  async trashItem() {
    let postID = this.props.item.post_url;
    console.log('trash post and comp:', postID, this.compObj.id);
    return;

    // delete composition on widgetic promise
    const deleteCompositionPromise = window.Widgetic.api(
      `compositions/${this.compObj.id}`,
      'delete'
    );

    // delete post on wordpress account
    const deletePostPromise = this.props.wp
      .posts()
      .id(postID)
      .delete({ force: false });

    // call promises
    await Promise.all([deleteCompositionPromise, deletePostPromise]);

    console.log('trashed composition:', postID, compId);
  }

  // RENDER
  render() {
    return (
      <>
        <Flex className='comp-item'>
          {/* COMPOSITION THUMB */}
          <FlexItem>
            <img
              with='40px'
              height='40px'
              src={Thumb}
              alt='Composition thumbnail'
            />
          </FlexItem>

          {/* COMPOSITION NAME and link to edit post */}
          {!this.state.isEdit && (
            <FlexItem>
              <a
                href={`/?p=${this.props.item.post_url}`}
                target='_blank'
                rel='noreferrer'
              >
                {this.state.compName}
              </a>
            </FlexItem>
          )}

          {/* COMPOSITION NAME input and RENAME button */}
          {this.state.isEdit && (
            <>
              {/* NAME input */}
              <FlexItem>
                <InputControl
                  value={this.state.compName}
                  onChange={(nextValue) =>
                    this.setState({ compName: nextValue })
                  }
                />
              </FlexItem>
              {/* RENAME button */}
              <FlexItem>
                <Button
                  isPrimary
                  onClick={() => {
                    // close renaming the item
                    this.setState({ isEdit: false });

                    // rename the composition on Widgetic
                    this.renameItem();
                  }}
                >
                  Rename
                </Button>
              </FlexItem>
              {/* CANCEL button */}
              <FlexItem>
                <Button isSecondary onClick={() => setState({ isEdit: false })}>
                  Cancel
                </Button>
              </FlexItem>
            </>
          )}
          <FlexBlock />

          {/* COMPOSITION DATE */}
          <FlexItem style={{ marginRight: 'calc(4px * 2)' }}>
            {this.props.item.date}
          </FlexItem>

          {/* MORE BUTTON and DROPDOWN */}
          <DropdownMenu
            icon={moreVertical}
            controls={[
              {
                title: 'Edit Block',
                icon: edit,
                onClick: () =>
                  window.open(
                    `/wp-admin/post.php?post=${this.props.item.post_url}&action=edit`,
                    '_blank'
                  ),
              },
              {
                title: 'Rename',
                icon: edit,
                onClick: () => this.setState({ isEdit: true }),
              },
              {
                title: 'Trash',
                icon: trash,
                onClick: () => this.trashItem(),
              },
            ]}
          />
        </Flex>
      </>
    );
  } // render end
}

export default CompositionItem;
